module.exports = __webpack_public_path__ + "assets/img/alborea.4327022c.png";